import requestService from "@/service/requestService";
import store from "@/store";
export class auth {
  timerRefreshToken: any;
  constructor() {
    let tokenKey = "factory";
    if (window.location.href.indexOf("user") > -1) {
      tokenKey = "user";
    }
    let _token = window.localStorage.getItem(tokenKey + "token");
    if(_token) {
      store.dispatch("Authentication/setToken", _token);
    }
  }
  pretendRequest(user: string, pass: string, part: string, cb: any) {
    setTimeout(() => {
      if (user && pass) {
        let req = new requestService();
        req.authentication({ id: user, pass: pass }).then(
          (res: any) => {
            const headerUuid = res.headers["x-shaken-uuid"];
            if (headerUuid) {
              window.localStorage.setItem("x-shaken-uuid", headerUuid[0]);
            }
            cb({
              authenticated: true,
              kyotenCd: res.kyotenCd,
              loginTypeKbn: res.loginTypeKbn,
              token: res.token,
              isDebug: res.isDebug
            });
          },
          (error: any) => {
            cb({ authenticated: false, error });
          }
        );
      } else {
        cb({ authenticated: false });
      }
    }, 0);
  }
  login(user: string, pass: string, part: string, cb: any) {
    cb = arguments[arguments.length - 1];
    this.pretendRequest(user, pass, part, (res: any) => {
      if (res.authenticated) {
        let tokenKey = this.getTokenKey();
        window.localStorage[tokenKey] = res.token;
        window.localStorage.kyotenCd = res.kyotenCd;
        window.localStorage.loginTypeKbn = res.loginTypeKbn;
        window.localStorage.isDebug = res.isDebug;
        /** 2021-07-28 sh #6989 when login, set token. [START] */
        /** APIの呼出しで、storeのトークンを使うため、ここで保存しておく */
        store.dispatch("Authentication/setToken", res.token);
        /** 2021-07-28 sh #6989 when login, set token. [END] */
      }
      if (cb) cb(res);
    });
  }

  checkAuthen() {
    var promise1 = new Promise((resolve, reject) => {
      let req = new requestService();
      req.refreshToken().then(
        (res: any) => {
          store.dispatch("Authentication/setToken", res.body.token);
          resolve(true);
        },
        (error: any) => {
          resolve(false);
        }
      );
    });
    return promise1;
  }
  refreshToken() {
    this.timerRefreshToken = setInterval(() => {
      let req = new requestService();
      req.refreshToken();
    }, 300000); // 5 minute
  }

  getToken() {
    let tokenKey = this.getTokenKey();
    return window.localStorage[tokenKey];
  }

  logout(cb: any) {
    let req = new requestService();
    req.logout();
    let tokenKey = this.getTokenKey();
    window.localStorage.removeItem(tokenKey);
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("kyotenCd");
    window.localStorage.removeItem("reservation-detail");
    if (cb) cb();
  }

  loggedIn() {
    let tokenKey = this.getTokenKey();
    return !!window.localStorage[tokenKey];
  }

  getTokenKey() {
    let tokenKey = "factory";
    if (window.location.href.indexOf("user") > -1) {
      tokenKey = "user";
    /** 2021-07-29 sh #6989 change condition from 'if' to 'else if'. [START] */
    // }
    // if (window.location.href.indexOf("quick") > -1) {
    } else if (window.location.href.indexOf("quick") > -1) {
    /** 2021-07-29 sh #6989 change condition from 'if' to 'else if'. [END] */
      tokenKey = "factory";
    }
    return tokenKey + "token";
  }

  onChange() {}
}
